import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { fmtDate } from './fleetUtils';
import DailyHistoryView from './DailyHistoryView';
import DriverHistoryView from './DriverHistoryView';

const TimelineDialog = ({ vehicle, open, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!open || !vehicle) return;
    setData(null);
    axios.get(`${API}/fleet/vehicles/${vehicle.vehicle_id}/timeline`, { withCredentials: true })
      .then((res) => setData(res.data))
      .catch((e) => { alert(e.response?.data?.detail || 'Erreur'); onClose(); });
  }, [open, vehicle]);

  if (!open) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="timeline-dialog">
        <DialogHeader><DialogTitle>Historique — {vehicle?.plate_number}</DialogTitle></DialogHeader>
        {!data ? <p className="text-sm text-gray-500 p-4">Chargement...</p> : (
          <div className="space-y-4">
            <div data-testid="timeline-driver-history-section">
              <h3 className="font-semibold text-sm mb-2">Historique des conducteurs</h3>
              <DriverHistoryView fixedVehicleId={vehicle.vehicle_id} compact />
            </div>
            <div data-testid="timeline-daily-history-section">
              <h3 className="font-semibold text-sm mb-2">Contrôles quotidiens</h3>
              <DailyHistoryView fixedVehicleId={vehicle.vehicle_id} compact />
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-2">Contrôles périodiques validés ({data.inspections.length})</h3>
              {data.inspections.length === 0 ? <p className="text-xs text-gray-400">Aucun contrôle validé</p> : (
                <div className="space-y-1">
                  {data.inspections.map((i) => (
                    <div key={i.inspection_id} className="text-xs border rounded p-2 flex justify-between">
                      <span>Semaine {i.week_key} par {i.admin_name} {i.mileage ? `· ${i.mileage} km` : ''}</span>
                      <span className="text-gray-500">{fmtDate(i.validated_at)} · {(i.issues_created || []).length} anomalie(s)</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-2">Événements ({data.events.length})</h3>
              <div className="space-y-2">
                {data.events.map((ev) => (
                  <div key={ev.event_id} className="text-xs border-l-2 border-blue-300 pl-2">
                    <p className="font-medium">{ev.action} {ev.old_status && ev.new_status ? `(${ev.old_status} → ${ev.new_status})` : ''}</p>
                    <p className="text-gray-500">{ev.actor?.name} ({ev.actor?.role}) — {fmtDate(ev.created_at)}</p>
                    {ev.comment && <p>{ev.comment}</p>}
                  </div>
                ))}
                {data.events.length === 0 && <p className="text-xs text-gray-400">Aucun événement</p>}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TimelineDialog;
